// src/Components/privateRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ usuario, children, requiredRole, userRole }) => {
  // Verifica si el usuario está logueado, su email está verificado y si su rol está en el array de requiredRole
  if (!usuario || !usuario.emailVerified) {
    return <Navigate to="/login" replace />; // Agregar replace
  }
  if (!requiredRole) {
    return children;
  }
  if (!requiredRole.includes(userRole)) {
    console.log(!requiredRole.includes(userRole));
    return <Navigate to="/" replace />; // Agregar replace
  }
  return children;
};

export default PrivateRoute;
